import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Detalle, Dte, Envio, Sobre, Totales } from '../interfaces/dte.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SimpleApiService {

  apiDte = environment.apiDte;

  constructor(
    private http: HttpClient
  ) { }

  dteGenerar(formData: FormData) {
    return this.http
      .post(`${this.apiDte}/dte/generar`, formData, {
        responseType: 'blob',
      })
      .toPromise();
  }

  envioGenerar(formData: FormData) {
    return this.http
      .post(`${this.apiDte}/envio/generar`, formData, {
        responseType: 'blob',
      })
      .toPromise();
  }

  envioEnviar(formData: FormData) {
    return this.http
      .post(`${this.apiDte}/envio/enviar`, formData)
      .toPromise();
  }

  generarSobreJson() {
    const sobre: Sobre = {
      Caratula: {
        FechaResolucion: '2014-10-21',
        NumeroResolucion: '99',
        RutEmisor: '15491994-5',
        RutReceptor: '60803000-K',
      },
      Certificado: {
        Rut: '15491994-5',
        Password: 'shirley777',
      }
    };

    return sobre;
  }

  generarEnvioJson() {
    const envio: Envio = {
      Certificado: {
        Rut: '15491994-5',
        Password: 'shirley777',
      },
      Ambiente: 1,
      Tipo: 2,
    };

    return envio;
  }

  generarDteJson(
    folio: number,
    Totales: Totales,
    Detalles: Detalle[]
  ) {
    const dte: Dte = {
      Documento: {
        Encabezado: {
          IdentificacionDTE: {
            TipoDTE: 39,
            Folio: folio,
            FechaEmision: moment().format('YYYY-MM-DD'),
            IndicadorServicio: 3,
          },
          Emisor: this.crearEmisor(),
          Receptor: this.crearReceptor(),
          Totales,
        },
        Detalles,
      },
      Certificado: {
        Rut: '15491994-5',
        Password: 'shirley777',
      },
    };

    return dte;
  }

  crearEmisor() {
    return {
      Rut: '15491994-5',
      RazonSocialBoleta: 'SHIRLEY CATHERINE PASTENE NAVARRETE',
      GiroBoleta: 'PASTELERIA Y PANADERIA',
      DireccionOrigen: 'Vega de Saldias 278',
      ComunaOrigen: 'Chillan',
    };
  }

  crearReceptor() {
    
    return {
      Rut: '66666666-6',
      RazonSocial: 'Cliente Generico',
      Direccion: 'Direccion Generica',
      Comuna: 'Chillan',
    };
    
  }
}
